import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface TooltipProps {
  $whiteSpace?: 'pre' | 'pre-wrap';
}

export const Wrapper = styled.div<TooltipProps>`
  // Only show tooltip on hover with pointing device
  @media (any-hover: hover) and (any-pointer: fine) {
    position: relative;
    max-width: max-content;

    &:hover {
      &::before {
        content: attr(data-tooltip);
        position: absolute;
        left: 50%;
        bottom: calc(100% + ${size(0.5)});
        transform: translateX(-50%);
        padding: ${size(0.25)} ${size(0.75)};
        background-color: var(--c-contrast-bg);
        color: var(--c-contrast-fg);
        white-space: nowrap;
        font-size: ${(props) => props.theme.font.size.xsmall};
        border-radius: var(--border-radius);

        ${({ $whiteSpace }) =>
          $whiteSpace &&
          css`
            white-space: pre;
          `}
      }
    }
  }
`;
